import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import Input from '../component/Input.js';
import loader from '../asset/img/loader.gif';
import Modal from 'react-modal';
import SelectBox from '../component/Select.js';
import Validation from './Validation.js';

export default class CreatePrize extends Component{
	constructor(props){
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.handleFile = this.handleFile.bind(this);
		this.handlePic = this.handlePic.bind(this);
		this.addRows = this.addRows.bind(this);
		this.logColor = this.logColor.bind(this);
		this.logSizes = this.logSizes.bind(this);
		this.setVariants = this.setVariants.bind(this);
		this.onCreate = this.onCreate.bind(this);
		this.reconcileVariants = this.reconcileVariants.bind(this);
		this.putVariants = this.putVariants.bind(this);
		this.fileInput = React.createRef();
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.isImage = this.isImage.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.state = {prize:'',tier:1,cap:'',picture:'',description:'',noPic:'',variants:[],files:[],rows:1,modalIsOpen:false,modalPrompt:'',loading:false};
	}

	loadingFunc(loading){ //method for displaying the loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false});
		}
	}

	isImage(file){ //method to determine whether or not an uploaded file is an image (validate file uploads to prevent malicious code/programs from being uploaded)
		 return (file['type'].split('/')[0] == 'image');
	}

	handleInput(identity,value){ //standard method for updating the state based on user input
		const theState = this.state;
		theState[identity] = value;
		this.setState(theState);
	}

	openModal(){ //method for opening the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //method for closing the modal
		this.setState({modalIsOpen:false,modalPrompt:''});
	}

	addRows(){
		let rows = this.state.rows + 1;
		this.setState({rows:rows});
	}

	setVariants(variants){
		this.setState(oldState => ({variants:[...oldState.variants,variants]}));
	}

	handleFile(){ //method that stores correct file name for each picture that is uploaded
		let fileNames = [];
		let variants = [];
		let files = [];
		for(let i = 0;i<this.fileInput.current.files.length;i++){
			if(this.isImage(this.fileInput.current.files[i])){
				fileNames.push("lov_"+(this.fileInput.current.files[i].name).replace(/\s/g,"_"));
				files.push(this.fileInput.current.files[i]);
				variants.push({color:'',sizes:''});
			}
		}
		this.setState({picture:fileNames,variants:variants,files:files});
	}

	handlePic(identity,value){ //handles changing the name of each picture uploaded based on the color it is associated with
		const theState = this.state.picture;
		let endIndex = theState[identity].lastIndexOf(".");
		let ext = theState[identity].substr(endIndex);
		value = value.trim().toLowerCase()+ext;
		theState[identity] = value.replace(/\s/g,"_");
		this.setState({picture:theState});
	}

	logColor(identity,value){ //method for logging each color value in the state
		let variants = this.state.variants;
		variants[identity].color = value;
		this.setState({variants:variants});
		this.handlePic(identity,value);
	}

	logSizes(identity,value){ //method for logging each size value in the state
		let variants = this.state.variants;
		variants[identity].sizes = value;
		this.setState({variants:variants});
	}

	reconcileVariants(){ //method for organizing and compiling all variant values together to get ready to send to database
		let pictures = this.state.picture;
		let noPic = this.state.noPic;
		let fixedVariants = [];
		let variants = this.state.variants;
		for(let i=0;i<variants.length;i++){ //create a variant for each size and color combo with its corresponding picture
			let sizes = variants[i].sizes.split(",");
			sizes.forEach((size)=>{
				fixedVariants.push({size:size.trim(),color:variants[i].color.trim(),photo:pictures[i]});
			});
		}

		if(noPic !== ''){ //format all variants without pictures
			let otherVariants = noPic.split("\n");
			otherVariants = otherVariants.map(variant=>{
				return variant.split(";").map(next=>{
					return next.split(":");
				});
			});
			otherVariants.forEach((varArray)=>{
					let sizes = varArray[0][1].split(",");
					let colors = varArray[1][1].split(",");
					for(let i = 0;i<sizes.length;i++){
						for(let j = 0;j<colors.length;j++){
							fixedVariants.push({size:sizes[i],color:colors[j],photo:pictures[0]});
						}
					}
			});
		}

		this.setState({variants:fixedVariants});
	}

	putVariants(id){ //method for storing all variants in the database
		let variants = this.state.variants;
		let merge = [].concat.apply([],variants);
		if (merge.length === 0){
			merge.push({size:null,color:null});
		}
		let variantCalls = [];
		merge.forEach((variant)=>{ //format all variant data
			const size = (variant.size === '' || variant.size === undefined)?null:variant.size.replace(/\s/g,"_");
			const color = (variant.color === '' || variant.color === undefined)?null:variant.color.replace(/\s/g,"_");
			variantCalls.push(axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'variants',misc:'create',firstID:id,secondID:this.props.year,status:size,name:color,picture:"_"+variant.photo}
			}));
		});
		axios.all(variantCalls).then(()=>{ //send all variants
			this.props.revertSave();
			this.setState({prize:'',tier:'',cap:'',picture:'',description:'',noPic:'',variants:[],rows:1,modalPrompt:'Prize successfully created!'},function(){
				this.loadingFunc(false);
			});
			this.props.reset(this.props.year);
			setTimeout(()=>{
				this.closeModal();
			},1500);
		});
	}

	onCreate(newPrize){ //method to create main prize information (tier, year, type, picture path, name of prize, description)
		const cap = (newPrize.cap === '' || newPrize.cap === 0)?null:newPrize.cap;
		const picture = "lov_"+newPrize.prize.replace(/\s/g,"_").replace(/'/g,"_").toLowerCase();
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'prizes',misc:'create',firstID:newPrize.tier,secondID:this.props.year,quantity:cap,status:'lov',name:newPrize.prize,picture:picture,desc:newPrize.description}
		}).then((response)=>{
			let data = response.data.data;
			if(data.ID !== 0){
				this.reconcileVariants();
				this.putVariants(data.ID);
			}else{
				this.setState({modalPrompt:"Prize already exists!"},function(){
					this.loadingFunc(false);
				});
				this.props.revertSave();
			}
		})
	}

	componentDidUpdate(prevProps,prevState){
		if(prevProps.save !== this.props.save && this.props.save){ //if user has chosen to save/create prize
			document.getElementById("desc").classList.remove("invalid");
			document.getElementById("prize").classList.remove("invalid");
			document.getElementById("noPic").classList.remove("invalid");
			const {tier,picture,files} = this.state;
			let noPic = this.state.noPic;
			let prize = this.state.prize;
			let description = this.state.description;
			let validColors = true;
			let noColorCount = 0;
			if(picture.length >= 1){ //make sure that each picture has its color listed if there is more than one picture
				for(let i=0;i<this.state.variants.length;i++){
					if(this.state.variants[i].color === ''){
						noColorCount++;
					}
				}
			}
			if(picture.length === 1 && noColorCount > 1){
				validColors = false;
			}else if(picture.length > 1 && noColorCount > 0){
				validColors = false;
			}
			if((prevProps.save !== this.props.save) && this.props.save && picture.length > 0 && Validation("prize",prize.trim()) && Validation("prize",description.trim()) && validColors){//if user has chosen to create prize and input is valid
				let validNoPic = true;
				if(noPic !== ''){ //make sure all no picture variants are valid
					if(/\n/.test(noPic)){
						noPic = noPic.split("\n");
						noPic.forEach((line)=>{
							if(!(Validation("noPic",line))){
								validNoPic = false;
							}
						});
					}else{
						if(!(Validation("noPic",noPic))){
							validNoPic = false;
						}
					}
				}
				let validVariants = true;
				if(this.state.variants.length > 0){ //make sure all variants are valid
					this.state.variants.forEach((variant)=>{
						if(variant.sizes !== '' && !Validation("size",variant.sizes)){
							validVariants = false;
						}
						if(variant.color !== '' && !Validation("color",variant.color)){
							validVariants = false;
						}
					});
				}
				if(picture !== '' && prize.trim() !== '' && description.trim() !== ''){
					if(validNoPic && validVariants){
						let success = [];
						let calls = [];
						this.loadingFunc(true);
						for(let i=0;i<files.length;i++){ //send variant picture files to server
							let name = prize.trim().toLowerCase().replace(/\s/g,"_");
							if(picture.length > 1){
								name = name+"_"+picture[i];
							}else{
								name = name+"_"+picture[0];
							}
							let data = new FormData();
							data.append('file[]',files[i],"lov_"+name);
							calls.push(axios({
											 	method:'post',
											 	url:path,
											 	headers:{'Content-Type':'application/json'},
											 	data:data
											 }).then((response)=>{
											 	let data = response.data.data;
											 		if(data !== "error"){
											 			success.push(data);
											 		}
											 }));
						}
						axios.all(calls).then(()=>{ //once all pictures have been stored, create the prize
								this.onCreate(this.state);
						});
					}else{
						if(validVariants){ //noPic variants contains invalid input
							document.getElementById("noPic").classList.add("invalid");
							this.setState({modalPrompt:'Please follow the correct format for "Variants without pictures".'},function(){
								this.openModal();
								this.props.revertSave();
							});
						}else{
							if(validNoPic){
								document.getElementById("noPic").classList.remove("invalid");
							}
							let j;
							let sizeElements = document.getElementsByClassName("sizeInput");
							let colorElements = document.getElementsByClassName("colorInput");
							for(j=0;j<sizeElements.length;j++){ //highlight whichever size inputs are invalid
								if(sizeElements[j].value !=='' && !Validation("size",sizeElements[j].value)){
									sizeElements[j].classList.add("invalid");
								}else{
									sizeElements[j].classList.remove("invalid");
								}
							}
							for(j=0;j<colorElements.length;j++){ //highlight whichever color inputs are invalid
								if(colorElements[j].value !=='' && !Validation("color",colorElements[j].value)){
									colorElements[j].classList.add("invalid");
								}else{
									colorElements[j].classList.remove("invalid");
								}
							}
							this.setState({modalPrompt:'Please enter variants in the correct format.'},function(){
								this.openModal();
								this.props.revertSave();
							});
						}
					}
				}else{
					if(picture === ''){ //highlight picture label
						document.getElementById("pic").classList.add("invalidLabel");
					}else{
						document.getElementById("pic").classList.remove("invalidLabel");
					}
					if(prize.trim() === ''){ //highlight prize input
						document.getElementById("prize").classList.add("invalid");
					}else{
						document.getElementById("prize").classList.remove("invalid");
					}
					if(description.trim() === ''){ //highlight description input
						document.getElementById("desc").classList.add("invalid");
					}else{
						document.getElementById("desc").classList.remove("invalid");
					}
					this.setState({modalPrompt:'All fields except for "variants without pictures" are required.'},function(){
						this.openModal();
						this.props.revertSave();
					});
				}
			}else if((prevProps.save !== this.props.save) && this.props.save && picture.length < 1 || !Validation("prize",prize.trim()) || !Validation("prize",description.trim()) || !validColors){
				let modalPrompt = '';
				if(picture.length < 1){ //if no pictures have been chosen
					modalPrompt += 'At least one picture is required for each prize.\n';
					document.getElementById("pic").classList.add("invalidLabel");
				}else{
					document.getElementById("pic").classList.remove("invalidLabel");
				}

				if(!validColors){ //if multiple pictures chosen but colors not specified
					modalPrompt += 'Colors need to be specified if there is more than one photo.\n';
					let elements = document.getElementsByClassName("colorInput");
					for(let i=0;i<elements.length;i++){
						if(elements[i].value.trim() === ''){
							elements[i].classList.add("invalid");
						}else{
							elements[i].classList.remove("invalid");
						}
					}
				}
				if(!Validation("prize",prize.trim()) || !Validation("prize",description.trim())){ //if prize or description are not valid
					modalPrompt += 'Prize name and/or description does not contain valid input.\n';
					if(!Validation("prize",prize.trim())){ //if prize is not valid
						document.getElementById("prize").classList.add("invalid");
					}else{
						document.getElementById("prize").classList.remove("invalid");
					}
					if(!Validation("prize",description.trim())){ //if description is not valid
						document.getElementById("desc").classList.add("invalid");
					}else{
						document.getElementById("desc").classList.remove("invalid");
					}
				}

				this.setState({modalPrompt:modalPrompt},function(){
						this.openModal();
						this.props.revertSave();
				});
			}
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};
		const picstyles= {display:'block', maxWidth:'100px',maxHeight:'100px',width:'auto',height:'auto',margin:'auto'};
		let picPreviews = [];
		const inputStyles = "h2 br2 bw1 w-100 shadow-3 pl2 pr2";
		const areaStyles="br2 bw1 h3 w-100 shadow-3 pa2";
		let modalContent;
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else{ //display error/success message
			modalContent = <div>
												<div className="fl w-100 tr pb2">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
												<p className="b navy f4 tc">{this.state.modalPrompt}</p>
											</div>
		}
		if(this.state.picture !== ''){ //display image previews with color and size input fields for each image
				for(let i=0;i<this.state.files.length;i++){
				let prevURL = URL.createObjectURL(this.state.files[i]);
				picPreviews.push( <div className="fl w-33-ns w-50 mv3" style={{height:'200px'}} key={i}>
														<div className="mt0">
															<div style={{width:'100px',height:'100px',margin:'auto'}} className="tc">
																<img src={prevURL} alt="error" style={picstyles}/>
															</div>
															<div style={{maxWidth:'100px',margin:'auto'}}>
																<div className="pb1">
																	<label>color: </label>
																	<Input identity={i} onInput={this.logColor} placeholder="color" inputStyle="h2 br2 bw1 w-100 shadow-3 pl2 pr2 colorInput"/>
																</div>
																<div>
																	<label>sizes: </label>
																	<Input identity={i} onInput={this.logSizes} placeholder="xl,med,..." inputStyle="h2 br2 bw1 w-100 shadow-3 pl2 pr2 sizeInput"/>
																</div>
															</div>
														</div>
													</div> );
			}
		}
		return(
			<div className="w-60-ns w-80-m w-90 center" >
				<div className="fl w-100 mt3">
					<div className="fl w-50-ns w-100">
						<div className="fl w-100">
							<label className="b">Prize name: </label>
						</div>
						<div className="fl w-100 pr2">
							<Input identity="prize" onInput={this.handleInput} id="prize" val={this.state.prize} inputStyle={inputStyles}/>
						</div>
					</div>
					<div className="fl w-25-ns w-50 mt0-ns mt2">
						<div className="fl w-100">
							<label className="b">Tier: </label>
						</div>
						<div className="fl w-100 pr2">
							<SelectBox name="tier" identity="tier" onSelect={this.handleInput} options={this.props.tiers} styles={inputStyles} val={this.state.tier}/>
						</div>
					</div>
					<div className="fl w-25-ns w-50 mt0-ns mt2">
						<div className="fl w-100">
							<label className="b">Cap: </label>
						</div>
						<div className="fl w-100 pr2">
							<Input identity="cap" onInput={this.handleInput} val={this.state.cap} inputStyle={inputStyles} type="number"/>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt3">
					<div className="fl w-100">
						<label className="b">Description: </label>
					</div>
					<div className="fl w-100 pr2">
						<Input type="text" identity="description" id="desc" inputStyle={inputStyles} onInput={this.handleInput} val={this.state.description}/>
					</div>
				</div>
				<div className="fl w-100 mt3">
					<div className="fl w-20">
						<label className="b" id="pic">Picture(s): </label>
					</div>
					<div className="fl w-80 pl2 overflow-x-hidden">
						<div className="ml2">
							<input type="file" name="file" onChange={this.handleFile} ref={this.fileInput} accept="image/*" multiple/>
						</div>
					</div>
				</div>
				<div className="pics ml2-ns" style={{maxWidth:'525px',margin:'auto'}}>
				{picPreviews}
				</div>
				<div className="fl w-100 mt3 pb3">
					<div className="fl w-100 tl pr2">
						<label className="b">Variants without pictures: </label>
						<Input type="area" identity="noPic" id="noPic" styles={areaStyles} onInput={this.handleInput} val={this.state.noPic} placeholder="i.e. sizes:xl;colors:red,green,blue"/>
					</div>
				</div>
				<div>
					<Modal
		          isOpen={this.state.modalIsOpen}
		          style={customStyles}
		          contentLabel="loading/message"
		          shouldCloseOnOverlayClick={false}
		          shouldCloseOnEsc={false}
		        >
		        {modalContent}
		        </Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/CreatePrize.js